// export const baseURL = 'https://admin.sadaynaal.com';
export const baseURL = 'https://admin.chefadmin.com';

// export const foodics_integration_url =
//   'https://console-sandbox.foodics.com/authorize'; // For portal

export const foodics_integration_url = 'https://console.foodics.com/authorize'; // For live
